
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import axios from 'axios'
import * as Sentry from '@sentry/vue'

import { Job, TranslationActivity } from '@/domains/global/models'
import ConfirmModal from '@/domains/global/components/ConfirmModal.vue'
import { consumeError } from '@/domains/global/utils'

import TemplateActivityView from './TemplateActivityView.vue'
import FullTranslationActivityView from './FullTranslationActivityView.vue'

@Component({
  components: { TemplateActivityView, FullTranslationActivityView }
})
export default class TranslationActivityView extends Vue {
  @Prop({ type: Object, required: true })
  private readonly activity!: TranslationActivity

  @Prop({ type: Object, required: true })
  private readonly job!: Job

  get isSubmitted () {
    return !this.activity.isDraft
  }

  get isTemplateActivity() {
    return this.activity.documentType !== 'adhoc'
  }

  get agencyId () {
    return this.$store.state.auth.agencyId
  }

  get isOnlyCustomer () {
    return this.job.type === 'agency' && this.job.agencyId !== this.agencyId
  }

  get submitConfirm () {
    return this.$refs.submitConfirm as ConfirmModal<TranslationActivity>
  }

  confirmSubmit () {
    this.submitConfirm.open(this.activity)
  }

  async submitActivity (activity: TranslationActivity) {
    try {
      await axios.put(`/jobs/${activity.jobId}/activities/${activity.id}/submit`)
      this.$emit('submit')
    } catch (error: any) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        await this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }
}
